"use client"

import { lazy, Suspense } from 'react'
import { useStore } from '@/lib/store'
import { useFeature } from '@/hooks/use-feature'
import { useWaiterAccess } from '@/lib/use-waiter-access'
import { tillDutiesFor } from '@/lib/tables-store'

const TillReceiver = lazy(() => import('./till-receiver'))

/**
 * 1.68 (196) — the till's café duties, in the shop's shell (spec G13): the bar's queue and the waiters' checks keep
 * working while the cashier sells on the plain cart or is in a checkout. Light here — the receiver itself loads only on
 * a device with a duty in this shop and branch, with the tables switch on; never a waiter's phone, the accountant or a
 * support session (the database refuses them anyway). A new shop or branch remounts it: nothing carries over.
 */
export function TillReceiverMount() {
  const tablesOn = useFeature('tables')
  const hydrated = useStore((s) => s.isHydrated)
  const orgId = useStore((s) => s.currentOrg?.id ?? null)
  const branchId = useStore((s) => s.activeBranchId)
  const duties = useStore((s) => s.tillDuties)
  const role = useStore((s) => s.userRole)
  const support = useStore((s) => !!s.supportSession)
  const waiter = useWaiterAccess()
  const d = tillDutiesFor(duties, orgId, branchId)
  if (!hydrated || !tablesOn || support || waiter !== 'none' || (role !== 'owner' && role !== 'cashier')) return null
  if (!d.bar && !d.checks) return null
  return (
    <Suspense fallback={null}>
      <TillReceiver key={`${orgId}:${branchId}`} bar={d.bar} checks={d.checks} />
    </Suspense>
  )
}
